import { UserAvatar } from "@/components/user-avatar/user-avatar";

export function UserCell({
  azureObjectUuid,
  firstName,
  lastName,
}: {
  azureObjectUuid: string;
  firstName: string;
  lastName: string;
}) {
  return (
    <div className="flex place-items-center gap-2 text-left font-medium">
      <UserAvatar name={`${lastName}, ${firstName}`} userAzureObjectUuid={azureObjectUuid} />
      <p>
        {lastName}, {firstName}
      </p>
    </div>
  );
}
